const en = {
    connectionError:
        'Could not connect to the storage. Check your connection and try again.',
    retryConnection: 'Reconnect',
    title: 'Files',
    storage: 'Storage',
    root: 'All files',
    location: 'Folder navigation',
    parent: 'Parent folder',
    file: 'File',
    folder: 'Folder',
    open: 'Open folder',
    download: 'Download',
    downloadFolder: 'Download archive',
    actions: 'Actions',
    rename: 'Rename',
    remove: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    name: 'Name',
    working: 'Working…',
    renaming: 'Renaming…',
    deleting: 'Deleting…',
    loading: 'Loading files…',
    connectionPhases: {
        quota: 'Requesting traffic quota…',
        discovery: 'Checking connection…',
        connecting: 'Creating a tunnel to storage…',
        health: 'Checking storage availability…',
    },
    empty: 'This folder is empty',
    emptyHint: 'Create a folder or add your first file.',
    confirmFile: 'Delete this file?',
    confirmFolder: 'Delete this folder and everything inside?',
    permanent: 'This action cannot be undone.',
    confirmDelete: 'Delete permanently',
    refresh: 'Refresh file list',
    loadError: 'Could not load files. Try refreshing the list.',
    refreshError:
        'Could not refresh the list. The displayed files may be out of date.',
    count: 'Items',
    errors: {
        emptyName: 'Enter a name.',
        reservedName: 'The names “.” and “..” are reserved.',
        invalidName: 'Use a name without /, \\ or null characters.',
        alreadyExists: 'A file or folder with this name already exists.',
        forbidden: 'You do not have permission for this action.',
        notFound: 'The item is no longer available. Refresh the file list.',
        failed: 'The server could not complete the action.',
        unconfirmed:
            'Could not confirm the result. Refresh the file list before trying again.',
    },
}
type Messages = Omit<
    Record<keyof typeof en, string>,
    'errors' | 'connectionPhases'
> & {
    errors: Record<keyof typeof en.errors, string>
    connectionPhases: Record<keyof typeof en.connectionPhases, string>
}
const ru: Messages = {
    connectionError:
        'Не удалось подключиться к хранилищу. Проверьте соединение и попробуйте снова.',
    retryConnection: 'Подключиться снова',
    title: 'Файлы',
    storage: 'Хранилище',
    root: 'Все файлы',
    location: 'Навигация по папкам',
    parent: 'На уровень выше',
    file: 'Файл',
    folder: 'Папка',
    open: 'Открыть папку',
    download: 'Скачать',
    downloadFolder: 'Скачать архив',
    actions: 'Действия',
    rename: 'Переименовать',
    remove: 'Удалить',
    save: 'Сохранить',
    cancel: 'Отмена',
    name: 'Название',
    working: 'Выполняется…',
    renaming: 'Переименовываем…',
    deleting: 'Удаляем…',
    loading: 'Загружаем файлы…',
    connectionPhases: {
        quota: 'Запрашиваем квоту трафика…',
        discovery: 'Проверяем соединение…',
        connecting: 'Создаём туннель к хранилищу…',
        health: 'Проверяем доступность хранилища…',
    },
    empty: 'В этой папке пока пусто',
    emptyHint: 'Создайте папку или добавьте первый файл.',
    confirmFile: 'Удалить этот файл?',
    confirmFolder: 'Удалить папку и всё её содержимое?',
    permanent: 'Это действие нельзя отменить.',
    confirmDelete: 'Удалить навсегда',
    refresh: 'Обновить список',
    loadError: 'Не удалось загрузить файлы. Попробуйте обновить список.',
    refreshError:
        'Не удалось обновить список. Показанные файлы могут быть неактуальны.',
    count: 'Элементов',
    errors: {
        emptyName: 'Введите название.',
        reservedName: 'Названия «.» и «..» зарезервированы.',
        invalidName: 'Название не должно содержать /, \\ или нулевой символ.',
        alreadyExists: 'Файл или папка с таким названием уже существует.',
        forbidden: 'У вас нет прав на это действие.',
        notFound: 'Элемент больше недоступен. Обновите список файлов.',
        failed: 'Сервер не смог завершить действие.',
        unconfirmed:
            'Не удалось подтвердить результат. Обновите список файлов перед повторной попыткой.',
    },
}
export const fileMessages = { en, ru }
